import API from "api/api/API";
import Cookies from "js-cookie";

export default class TemplateAPI {
  static async getCRMTemplates() {
    return API._bearerRequest(
      "get",
      "/global/templates",
      null,
      Cookies.get("authenticationToken")
    );
  }

  static async createTemplateFromCloudTenant(
    tenantID,
    name = "",
    description = ""
  ) {
    const payload = {
      Name: name,
      Description: description,
    };

    return API._bearerRequest(
      "post",
      "/global/templates/from-cloud/" + tenantID,
      payload,
      Cookies.get("authenticationToken")
    );
  }

  static async createCRMTemplate(name, description) {
    const payload = {
      Name: name,
      Description: description,
    };

    return API._bearerRequest(
      "post",
      "/global/templates",
      payload,
      Cookies.get("authenticationToken")
    );
  }

  static async editCRMTemplateInfo(id, name, description) {
    const payload = {
      Name: name,
      Description: description,
    };

    return API._bearerRequest(
      "put",
      `/global/templates/${id}/information`,
      payload,
      Cookies.get("authenticationToken")
    );
  }

  static async deleteCRMTemplate(id) {
    return API._bearerRequest(
      "delete",
      `/global/templates/${id}`,
      null,
      Cookies.get("authenticationToken")
    );
  }

  static async getTemplateById(id) {
    return API._bearerRequest(
      "get",
      `/global/templates/${id}`,
      null,
      Cookies.get("authenticationToken")
    );
  }

  static async createCRMTemplateModule(id, Name, APIName) {
    const payload = { Name, APIName };

    return API._bearerRequest(
      "post",
      `/global/templates/${id}/modules`,
      payload,
      Cookies.get("authenticationToken")
    );
  }

  static async deleteCRMTemplateModule(templateID, moduleAPIName) {
    return API._bearerRequest(
      "delete",
      `/global/templates/${templateID}/modules/${moduleAPIName}`,
      null,
      Cookies.get("authenticationToken")
    );
  }

  static async updateCRMTemplateModule(templateID, moduleAPIName, newName) {
    return API._bearerRequest(
      "put",
      `/global/templates/${templateID}/modules/${moduleAPIName}`,
      { Name: newName },
      Cookies.get("authenticationToken")
    );
  }

  static async createCRMTemplateModuleField(
    templateID,
    moduleAPIName,
    payload
  ) {
    return API._bearerRequest(
      "post",
      `/global/templates/${templateID}/modules/${moduleAPIName}/fields`,
      payload,
      Cookies.get("authenticationToken")
    );
  }

  static async modifyCRMTemplateModuleField(
    templateID,
    moduleAPIName,
    fieldAPIName,
    payload
  ) {
    return API._bearerRequest(
      "put",
      `/global/templates/${templateID}/modules/${moduleAPIName}/fields/${fieldAPIName}`,
      payload,
      Cookies.get("authenticationToken")
    );
  }

  static async deleteCRMTemplateModuleField(
    templateID,
    moduleAPIName,
    fieldAPIName
  ) {
    return API._bearerRequest(
      "delete",
      `/global/templates/${templateID}/modules/${moduleAPIName}/fields/${fieldAPIName}`,
      null,
      Cookies.get("authenticationToken")
    );
  }

  static async modifyTemplateModuleTemplate(
    templateID,
    moduleAPIName,
    templateName,
    payload
  ) {
    return API._bearerRequest(
      "put",
      `/global/templates/${templateID}/modules/${moduleAPIName}/templates/${templateName}`,
      payload,
      Cookies.get("authenticationToken")
    );
  }

  static async addTemplateModuleTag(templateID, moduleAPIName, tag) {
    return API._bearerRequest(
      "post",
      `/global/templates/${templateID}/modules/${moduleAPIName}/tags`,
      tag,
      Cookies.get("authenticationToken")
    );
  }

  static async updateTemplateModuleTag(
    templateID,
    moduleAPIName,
    tagID,
    newTag
  ) {
    return API._bearerRequest(
      "put",
      `/global/templates/${templateID}/modules/${moduleAPIName}/tags/${tagID}`,
      newTag,
      Cookies.get("authenticationToken")
    );
  }

  static async deleteTemplateModuleTag(templateID, moduleAPIName, tagID) {
    return API._bearerRequest(
      "delete",
      `/global/templates/${templateID}/modules/${moduleAPIName}/tags/${tagID}`,
      null,
      Cookies.get("authenticationToken")
    );
  }

  static async toggleTemplateModuleSidebarVisibility(
    templateID = "",
    moduleAPIName = "",
    visible = true
  ) {
    return API._bearerRequest(
      "put",
      `/global/templates/${templateID}/modules/${moduleAPIName}/sidebar`,
      { Visible: visible },
      Cookies.get("authenticationToken")
    );
  }

  static async duplicateCRMTemplate(
    templateID = "",
    name = "",
    description = ""
  ) {
    return API._bearerRequest(
      "post",
      `/global/templates/${templateID}/duplicate`,
      { Name: name, Description: description },
      Cookies.get("authenticationToken")
    );
  }
}
